'use client';

import Button from '@/components/atoms/button';
import { useEffect } from 'react';

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Lỗi Server:', error);
  }, [error]);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1 style={{ textTransform: 'uppercase' }}>😢 Server gặp lỗi</h1>
      <p>{error.message || 'Đã xảy ra lỗi khi tải trang'}</p>
      <div style={{ marginTop: 30 }}>
        <Button
          ariaLabel="Thử lại"
          shape="fill"
          variant="danger"
          onClick={() => {
            window.location.reload();
          }}
        >
          Thử lại
        </Button>
      </div>
    </div>
  );
}
